import BaseComponent from "../../baseComponent.js";
import TabList from "./tabList.jsx";
import CurrentTab from "./currentTab.jsx";
import DashboardService from "../../../core/services/dashboardService.js";
import styles from "../../common/dashboard-tab.scss";

export default class DashboardTabs extends BaseComponent {
  constructor(props) {
    super(props);
    const data = this.initTabs(props.tabs);
    this.state = {
      currentTab: data.currentTab,
      tabs: data.tabs,
      shared: data.shared
    };
  }

  componentDidMount() {
    this.$container = $(this.refs.container);
    this.show();
  }

  componentDidUpdate() {
    this.show();
  }

  componentWillReceiveProps(nextProps) {
    let data = this.initTabs(nextProps.tabs);
    this.setState({
      currentTab: data.currentTab,
      tabs: data.tabs,
      shared: data.shared
    });
  }


  initTabs(tabs) {
    const shared = tabs.filter(t => t.originalDashboard);
    const users = tabs.filter(t => !t.originalDashboard);

    this.setTabPosition(users);
    this.setTabPosition(shared);

    return {
      tabs: users,
      currentTab: tabs.find(t => t.activated),
      shared
    }
  }

  setTabPosition(tabs) {
    tabs.sort((a, b) => a.tabPosition - b.tabPosition);
    tabs.forEach((t, i) => t.tabPosition = i);
  }

  show() {
    setTimeout(() => {
      this.$container.css("opacity", 1);
    }, 500);
  }

  onTabChange(dashboardId) {
    this.$container.css("opacity", 0);
    this.props.onTabChange(dashboardId);
    localStorage.setItem("lastOpenedDashboard", dashboardId);
  }

  handleTabUpdate(dashboardId, newTitle) {
    let dashboard = this.state.tabs.find(t => t.persistenceId === dashboardId);
    dashboard.title = newTitle;
    DashboardService.updateDashboard(dashboard, dashboard);
    this.props.onDashboardUpdate();
  }

  handleReposition(dashboardId, newPosition, prevPosition, isSharedTabs = false) {
    const tabs = isSharedTabs ? this.state.shared : this.state.tabs;
    const dashboard = tabs.find(t => t.persistenceId === dashboardId);
    if (newPosition < prevPosition) {
      tabs.forEach(tab => {
        let pos = tab.tabPosition;
        if (pos >= newPosition && pos < prevPosition) {
          this.updatePosition(tab, tab.tabPosition + 1)
        }
      })

    } else {
      tabs.forEach(tab => {
        let pos = tab.tabPosition;
        if (pos > prevPosition && pos <= newPosition) {
          this.updatePosition(tab, tab.tabPosition - 1)
        }
      })
    }
    this.updatePosition(dashboard, newPosition)
      .then(() => {
        this.props.onDashboardUpdate();
      });
  }

  updatePosition(dashboard, newPosition) {
    dashboard.tabPosition = newPosition;
    return DashboardService.updateDashboard(dashboard, dashboard);
  }

  handleDelete(dashboardId) {
    this.props.onDashboardDelete(dashboardId);
  }

  handleAdd(title, pos) {
    let newTab = {
      title: title,
      tabPosition: pos
    };
    DashboardService.createDashboard(newTab)
      .then(() => {
        this.props.onDashboardUpdate();
      });
  }

  handleCopy() {
    DashboardService.copyCurrentDashboard()
      .then(dashboardId => {
        this.onTabChange(dashboardId);
      });
  }

  render() {
    return (
      <div id="tab-container" className={styles.dashboardTabs} ref="container">
        <CurrentTab tab={this.state.currentTab} key="currentTab"
                    onShare={this.props.onShare}
                    onDelete={this.props.onDashboardDelete}
                    onCopy={this.handleCopy}
                    onUpdate={this.handleTabUpdate}/>
        <TabList tabs={this.state.tabs} shard={this.state.shared} dashboardState={[]}
                 onUpdate={this.handleTabUpdate}
                 onReposition={this.handleReposition}
                 onTabChange={(id) => this.onTabChange(id)}
                 onAdd={this.handleAdd}
                 onDelete={this.handleDelete}
                 onDashboardUpdate={this.props.onDashboardUpdate}
                 onSharedDashboardDeleted={this.props.onSharedDashboardDeleted}
                 onShowTab={this.props.onShowTab}
                 key="tabList"/>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/tab/dashboardTabs.jsx